import {
  Avatar,
  Box,
  Button,
  Container,
  Flex,
  Heading,
  HStack,
  Link,
  Tag,
  TagLabel,
  TagLeftIcon,
  Text
} from '@chakra-ui/react'
import Card from 'components/Card'
import { NextPage } from 'next'
import { MdOutlineMedicalServices } from 'react-icons/md'
import NextLink from 'next/link'
import SEO from 'components/SEO'
import { FiArrowLeft } from 'react-icons/fi'
import RenderHTML from 'components/RenderHTML'

interface SpecialistProps {
  specialist: Record<string, any>
}

const Specialist: NextPage<SpecialistProps> = ({ specialist }) => {
  const photo = specialist.attributes.photo?.data
  const speciality = specialist.attributes.speciality?.data
  const metaDescription = String(specialist.attributes.description).substring(0, 256)

  return (
    <Container maxWidth="container.md" marginY="3rem">
      <SEO
        title={specialist.attributes.SEO?.metaTitle || specialist.attributes.fullName}
        description={specialist.attributes.SEO?.metaDescription || metaDescription}
      />
      <NextLink href="/zespol" passHref>
        <Button leftIcon={<FiArrowLeft />} variant="link">
          Zespół
        </Button>
      </NextLink>
      <Card width="100%" padding="1rem" marginTop="1rem">
        <HStack alignItems="center" gap="1rem">
          <Avatar name={specialist.attributes.fullName} src={photo?.attributes?.url} size="xl" />
          <Box flex={1}>
            <Flex display={['block', 'flex', 'flex']} justify="space-between" align="center">
              <Text>{specialist.attributes.title}</Text>
              {speciality && (
                <Box marginTop={['0.5rem', 0, 0]}>
                  <NextLink href={`/specjalnosc/${speciality.attributes.slug}`} passHref>
                    <Link>
                      <Tag variant="subtle" colorScheme="cyan" size="lg" borderRadius={0}>
                        <TagLeftIcon as={MdOutlineMedicalServices} />
                        <TagLabel>{speciality.attributes.name}</TagLabel>
                      </Tag>
                    </Link>
                  </NextLink>
                </Box>
              )}
            </Flex>
            <Heading size="md" marginTop={['0.5rem', 0, 0]}>
              {specialist.attributes.fullName}
            </Heading>
          </Box>
        </HStack>
        <Box marginTop="1rem" whiteSpace="pre-line" textAlign="justify">
          <RenderHTML>{specialist.attributes.description}</RenderHTML>
        </Box>
      </Card>
    </Container>
  )
}

export async function getStaticPaths() {
  const URL = `${process.env.NEXT_PUBLIC_API_URL}/api/specialists`
  const res = await fetch(URL)
  const { data } = await res.json()
  const paths = data?.map((specialist: any) => ({ params: { slug: specialist.attributes.slug } }))
  return {
    paths,
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }: any) {
  const { slug } = params
  const URL = `${process.env.NEXT_PUBLIC_API_URL}/api/slugify/slugs/specialist/${slug}?populate=photo,speciality,SEO`
  try {
    const res = await fetch(URL)
    const { data } = await res.json()
    return {
      props: {
        specialist: data
      },
      revalidate: 1
    }
  } catch {
    return {
      props: {},
      notFound: true
    }
  }
}

export default Specialist
